import { render } from "./RightColumn.vue?vue&type=template&id=8cde6a6a"
import script from "./RightColumn.vue?vue&type=script&lang=js"
export * from "./RightColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__